import type { AlgoliaCompanyRecord } from '../../types/company-search-record';

/**
 * Validates JSON body from GET /api/best-companies-hub.
 */
export function parseBestCompaniesHubApiPayload(raw: unknown): AlgoliaCompanyRecord[] {
  if (raw == null || typeof raw !== 'object') return [];
  const companies = (raw as { companies?: unknown }).companies;
  if (!Array.isArray(companies)) return [];
  return companies as AlgoliaCompanyRecord[];
}
